import agentBankDetailsFormDictionary from '@widgets/agent-bank-details-form/i18n/ru/agent-bank-details-form.dic.json';

export const agentBankDetailsForm = {
  AGENT_BANK_DETAILS_FORM: agentBankDetailsFormDictionary,
};

export const agentBankDetailsFormNamespaces = ['AGENT_BANK_DETAILS_FORM'];
